import { GradientBorderContainer } from "@/components/GradientBorderContainer";
import CheckWhite from "@/assets/Icons/check-white.svg?react";

interface BusinessCheckItemProps {
  title: string;
  content: string;
}

export const BusinessCheckItem = ({
  title,
  content,
}: BusinessCheckItemProps) => {
  return (
    <div className="w-full flex items-center h-fit">
      <GradientBorderContainer
        className="w-full !h-24 xs:!h-16 z-0"
        classNameContainer="flex items-center gap-3"
      >
        <CheckWhite className="w-4 h-4 flex-shrink-0" />
        <p className="font-medium text-white text-xs xs:text-sm">{title}</p>
      </GradientBorderContainer>
      <GradientBorderContainer
        className="w-full !h-24 xs:!h-16 z-1 -ml-6 from-sendolab-gray"
        classNameContainer="flex items-center gap-3 bg-gradient-to-r from-black to-sendolab-gray3 pl-10"
        noBackdrop
        gradientColor="gray"
      >
        <p className="font-light text-sendolab-white2 text-[11px] xs:text-xs">
          {content}
        </p>
      </GradientBorderContainer>
    </div>
  );
};
